import React from 'react';
import { Text } from 'react-native';
import {
  SectionHeading,
  SubSection,
  InputRow,
  DescriptionText,
  InputColumnSection,
} from '@/shared/styles/styledComponents/editProfileForm';
import {
  borderColor,
  green,
  disabledLightestGrey,
} from '@/shared/styles/colors';
import { User } from '@/shared/types/generated';
import useBreakpoint from '@/shared/hooks/useBreakpoint';
import { InputLabel } from '@/shared/components/StaticInput';
import { getCityLabel } from '@/components/explore/filters/utils';
import { BodyText } from '@/shared/components/StyledText';
import styled from '@emotion/native';

interface InPersonSessionSectionProps {
  user?: User;
}

const InPersonSessionSection: React.FC<InPersonSessionSectionProps> = ({
  user,
}) => {
  const { isDesktop } = useBreakpoint();

  const subSectionMarginBottom = isDesktop ? 12 : 18;

  if (!user?.stylist) {
    return null;
  }

  return (
    <SubSection marginBottom={subSectionMarginBottom}>
      <SectionHeading isDesktop={isDesktop}>In-Person Session</SectionHeading>
      <DescriptionText marginBottom={isDesktop ? 18 : 24}>
        To update your in-person availability status or your current location,
        contact support at:{' '}
        <Text
          style={{
            textDecorationLine: 'underline',
            fontWeight: 600,
          }}
        >
          support@emmestyling.com
        </Text>
      </DescriptionText>
      <InputRow isDesktop={isDesktop}>
        <InputColumnSection isDesktop={isDesktop}>
          <DisabledDropdownContainer isDesktop={isDesktop}>
            <InputLabel isVisible={true}>In-Person Status</InputLabel>
            <DisabledDropdownContent>
              <DisabledDropdownText>
                {user.stylist.computedInPersonAvailability
                  ? 'Available for in-person sessions'
                  : 'Not available for in-person sessions'}
              </DisabledDropdownText>
            </DisabledDropdownContent>
          </DisabledDropdownContainer>
        </InputColumnSection>
        <InputColumnSection isDesktop={isDesktop}>
          <DisabledDropdownContainer isDesktop={isDesktop}>
            <InputLabel isVisible={true}>Current City</InputLabel>
            <DisabledDropdownContent>
              <DisabledDropdownText>
                {user.address?.city
                  ? getCityLabel(user.address.city)
                  : 'No city set'}
              </DisabledDropdownText>
            </DisabledDropdownContent>
          </DisabledDropdownContainer>
        </InputColumnSection>
      </InputRow>
    </SubSection>
  );
};

const DisabledDropdownContainer = styled.View<{ isDesktop?: boolean }>(
  ({ isDesktop }) => ({
    backgroundColor: disabledLightestGrey,
    borderRadius: 36,
    paddingLeft: 26,
    marginBottom: 20,
    height: 50,
    justifyContent: 'center',
    borderColor: borderColor,
    borderWidth: 1,
    width: isDesktop ? '100%' : 326,
    position: 'relative',
  }),
);

const DisabledDropdownContent = styled.View({
  flexDirection: 'row',
  alignItems: 'center',
  flex: 1,
  paddingRight: 16,
});

const DisabledDropdownText = styled(BodyText)({
  color: green,
  fontSize: 16,
});

export default InPersonSessionSection;
